document.addEventListener("DOMContentLoaded", function () {
  // ------------------------------------------------
  // メディアクエリ監視
  // ------------------------------------------------
  const watchBreakpoint = window.matchMedia("(max-width: 768px)");

  // ------------------------------------------------
  // 定期バナー
  // ------------------------------------------------
  const banner = document.getElementById("customFixedBanner");
  if (banner) {
    // closeButtonはbannerの親要素内にある
    const bannerContainer = banner.closest(".custom-teiki-banner");
    const closeButton = bannerContainer
      ? bannerContainer.querySelector(".custom-teiki-banner__close")
      : null;

    // 「閉じる」処理（closeButtonが存在する場合のみ）
    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (bannerContainer) {
          bannerContainer.classList.add("is-hidden");
        }
      });
    }

    // バナークリックでリンク遷移
    banner.addEventListener("click", (e) => {
      // 閉じるボタンがクリックされた場合はリンク遷移しない
      if (closeButton && e.target.closest(".custom-teiki-banner__close")) {
        return;
      }
      const href = banner.getAttribute("href");
      if (href) {
        window.location.href = href;
      }
    });
  }

  // ------------------------------------------------
  // お客様の声
  // ------------------------------------------------
  const splideElement = document.querySelector(".custom-top-voice__splide");
  if (splideElement) {
    const splideVoice = new Splide(".custom-top-voice__splide", {
      // fixedWidth: 360,
      autoWidth: true,
      perMove: 1,
      gap: "40px",
      // arrows: false を削除 - 既存のHTMLボタンが自動的に認識される
      pagination: false,
      breakpoints: {
        768: {
          gap: "20px",
        },
      },
    });

    const bar = splideVoice.root.querySelector(
      ".custom-top-voice__progress-bar"
    );

    // プログレスバーの幅を更新
    splideVoice.on("mounted move", function () {
      if (bar) {
        const end = splideVoice.Components.Controller.getEnd() + 1;
        const rate = Math.min((splideVoice.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + "%";
      }
    });

    // Splideをマウント
    splideVoice.mount();
  }

  // ------------------------------------------------
  // おいしいアレンジ
  // ------------------------------------------------
  const splideArrangeElement = document.querySelector(
    ".custom-top-arrange__splide"
  );
  let splideArrange = null;

  const initSplideArrange = () => {
    if (splideArrangeElement && !splideArrange) {
      splideArrange = new Splide(".custom-top-arrange__splide", {
        fixedWidth: "224px",
        perMove: 1,
        gap: "80px",
        arrows: false,
        pagination: false,
        destroy: false,
      });
      splideArrange.mount();
    }
  };

  const destroySplideArrange = () => {
    if (splideArrange) {
      splideArrange.destroy();
      splideArrange = null;
    }
  };

  // 初期状態のチェック
  if (watchBreakpoint.matches) {
    initSplideArrange();
  }

  // メディアクエリの変更を監視
  watchBreakpoint.addEventListener("change", (e) => {
    if (e.matches) {
      initSplideArrange();
    } else {
      destroySplideArrange();
    }
  });

  // ------------------------------------------------
  // よくあるご質問
  // ------------------------------------------------
  const initializeAccordion = (details) => {
    const summary = details.querySelector("summary");
    const panel = details.querySelector("summary + *");

    if (!(details && summary && panel)) return; // 必要要素が揃ってない場合は処理をやめる

    // 初期状態を設定
    if (details.open) {
      // 開いた状態の場合は1frを設定
      panel.style.gridTemplateRows = "1fr";
    } else {
      // 閉じた状態の場合は0frを設定
      panel.style.gridTemplateRows = "0fr";
      panel.style.overflow = "hidden";
    }

    let isTransitioning = false; // 連打防止フラグ

    const onOpen = () => {
      if (details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;

      // まずopen属性を設定してからアニメーション
      details.setAttribute("open", "");
      panel.style.gridTemplateRows = "0fr";
      panel.style.overflow = "hidden";

      // 次のフレームでアニメーション開始
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          panel.style.gridTemplateRows = "1fr";
        });
      });

      panel.addEventListener(
        "transitionend",
        () => {
          isTransitioning = false;
          panel.style.overflow = "";
        },
        { once: true }
      );
    };

    const onClose = () => {
      if (!details.open || isTransitioning) {
        return;
      }
      isTransitioning = true;
      panel.style.gridTemplateRows = "0fr";
      panel.style.overflow = "hidden";

      panel.addEventListener(
        "transitionend",
        () => {
          details.removeAttribute("open");
          panel.style.gridTemplateRows = "";
          panel.style.overflow = "";
          isTransitioning = false;
        },
        { once: true }
      );
    };

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (details.open) {
        onClose();
      } else {
        onOpen();
      }
    });
  };

  // 両方のクラスに対応
  const accordions = document.querySelectorAll(
    ".custom-top-faq__item, .custom-faq__item"
  );
  accordions.forEach((details) => {
    initializeAccordion(details);
  });

  // ------------------------------------------------
  // スクロールクリップ
  // ------------------------------------------------

  // 要素をチェックしてクラスを付与する関数
  function checkScrollClip() {
    const windowHeight =
      window.innerHeight || document.documentElement.clientHeight;

    // 右からクリップ
    const scrollClipElements = document.querySelectorAll(
      ".js-scroll-clip-to-right:not(.js-clip-to-right)"
    );
    scrollClipElements.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < windowHeight - 100 && rect.bottom > 0) {
        element.classList.add("js-clip-to-right");
      }
    });

    // 上からクリップ
    const scrollClipElementsTop = document.querySelectorAll(
      ".js-scroll-clip-to-bottom:not(.js-clip-to-bottom)"
    );
    scrollClipElementsTop.forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < windowHeight - 100 && rect.bottom > 0) {
        element.classList.add("js-clip-to-bottom");
      }
    });
  }

  // 初回実行
  checkScrollClip();

  // スクロールイベントで実行（スロットル処理付き）
  let scrollTimer;
  window.addEventListener(
    "scroll",
    function () {
      if (scrollTimer) {
        return;
      }
      scrollTimer = setTimeout(function () {
        checkScrollClip();
        scrollTimer = null;
      }, 10);
    },
    { passive: true }
  );

  // リサイズ時も実行
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      checkScrollClip();
    }, 200);
  });
});



// ------------------------------------------------
// モーダル
// ------------------------------------------------
// モーダルを初期化する関数
const initializeModal = (modal) => {
  if (!modal) {
    // console.error("Element required for initializeModal is not found.");
    return;
  }

  const openTriggers = document.querySelectorAll(
    `[data-modal-open="${modal.id}"]`
  );
  const closeTriggers = modal.querySelectorAll("[data-modal-close]");

  // if (openTriggers.length === 0 || closeTriggers.length === 0) {
  if (openTriggers.length === 0 ) {
    // console.error("Elements required for modal trigger are not found.");
    return;
  }

  openTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (event) => handleOpenTriggerClick(event, modal, trigger),
      false
    );
    trigger.addEventListener("mousedown", handleTriggerFocus, false);
    trigger.addEventListener("keydown", handleTriggerFocus, false);
  });

  // closeTriggers.forEach((trigger) => {
  //   trigger.addEventListener(
  //     "click",
  //     (event) => handleCloseTriggerClick(event, modal),
  //     false
  //   );
  // });
  if (closeTriggers.length > 0) {
    closeTriggers.forEach((trigger) => {
      trigger.addEventListener(
        "click",
        (event) => handleCloseTriggerClick(event, modal),
        false
      );
    });
  }

  modal.addEventListener(
    "click",
    (event) => handleBackdropClick(event, modal),
    false
  );
};

// モーダルのアニメーションが完了するのを待つ
const waitModalAnimation = (modal) => {
  if (modal.getAnimations().length === 0) return Promise.resolve([]);
  return Promise.allSettled(
    modal.getAnimations().map((animation) => animation.finished)
  );
};

const eventListenersMap = new Map();

// イベントリスナーの管理
const manageEventListeners = (modal, add) => {
  const keyDownListener = (event) => handleKeyDown(event, modal);

  if (add) {
    window.addEventListener("keydown", keyDownListener, false);
    eventListenersMap.set(modal, { keyDownListener });
  } else {
    const listeners = eventListenersMap.get(modal);
    if (listeners) {
      window.removeEventListener("keydown", listeners.keyDownListener);
      eventListenersMap.delete(modal);
    }
  }
};

let currentOpenTrigger = null;

// トリガーのクリックイベントハンドラ
const handleOpenTriggerClick = (event, modal, trigger) => {
  event.preventDefault();
  currentOpenTrigger = trigger;
  openModal(modal);
};

const handleCloseTriggerClick = (event, modal) => {
  event.preventDefault();
  closeModal(modal);
};

// トリガーのフォーカスイベントハンドラ
const handleTriggerFocus = (event) => {
  if (event.type === "mousedown") {
    document.documentElement.setAttribute("data-mousedown", "true");
  }
  if (event.type === "keydown") {
    document.documentElement.removeAttribute("data-mousedown");
  }
};

// モーダルの背景クリックイベントハンドラ
const handleBackdropClick = (event, modal) => {
  if (event.target === modal) {
    closeModal(modal);
  }
};

// キーダウンイベントハンドラ
const handleKeyDown = (event, modal) => {
  document.documentElement.removeAttribute("data-mousedown");
  if (event.key === "Escape") {
    event.preventDefault();
    closeModal(modal);
  }
};

let isTransitioning = false;

// モーダルを開く
const openModal = (modal) => {
  if (isTransitioning) return;

  isTransitioning = true;
  modal.showModal();
  backfaceFixed(true);
  manageEventListeners(modal, true);

  requestAnimationFrame(async () => {
    modal.setAttribute("data-active", "true");
    await waitModalAnimation(modal);
    isTransitioning = false;
  });
};

// モーダルを閉じる
const closeModal = async (modal) => {
  if (isTransitioning) return;

  isTransitioning = true;
  modal.setAttribute("data-active", "false");
  backfaceFixed(false);
  manageEventListeners(modal, false);

  await waitModalAnimation(modal);
  modal.close();

  if (currentOpenTrigger) {
    currentOpenTrigger.focus();
    currentOpenTrigger = null;
  }

  isTransitioning = false;
};

// ドキュメントの書字方向を取得し、縦書きかどうかを判定
const isVerticalWritingMode = () => {
  const writingMode = window.getComputedStyle(
    document.documentElement
  ).writingMode;
  return writingMode.includes("vertical");
};

// スクロールバーの幅を計算する
const getScrollBarSize = () => {
  const scrollBarXSize =
    window.innerWidth - document.documentElement.clientWidth;
  const scrollBarYSize =
    window.innerHeight - document.documentElement.clientHeight;
  return isVerticalWritingMode() ? scrollBarXSize : scrollBarYSize;
};

// スクロール位置を取得する
const getScrollPosition = (fixed) => {
  if (fixed) {
    return isVerticalWritingMode()
      ? window.pageXOffset || document.documentElement.scrollLeft
      : window.pageYOffset || document.documentElement.scrollTop;
  }
  return parseInt(document.body.style.top || "0", 10);
};

// 背面固定のスタイルを適用する
const applyStyles = (scrollPosition, apply) => {
  const styles = {
    height: "100%",
    left: "0",
    position: "fixed",
    top: `-${scrollPosition}px`,
    width: "100%",
  };

  Object.entries(styles).forEach(([key, value]) => {
    document.body.style[key] = apply ? value : "";
  });
};

// 背面固定の処理
const backfaceFixed = (fixed) => {
  if (fixed) {
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.height = "";
    document.body.style.overflow = "";
  }
};

// DOMContentLoadedイベントで初期化を行う
// document.addEventListener("DOMContentLoaded", () => {
//  const modal = document.getElementById("modal1");
//  initializeModal(modal);
//});

document.addEventListener("DOMContentLoaded", () => {
  // すべてのモーダルを初期化
  const modals = document.querySelectorAll("dialog");
  modals.forEach(modal => {
    initializeModal(modal);
  });
});